// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCmRrafKckmFZfSgEi_2YJdYKZq2A-r_pg",
  authDomain: "nexusai-a5bde.firebaseapp.com",
  projectId: "nexusai-a5bde",
  storageBucket: "nexusai-a5bde.firebasestorage.app",
  messagingSenderId: "71869127737",
  appId: "1:71869127737:web:183ee8187710d90618c1e8",
  measurementId: "G-03F22X949W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
